import React, { memo, useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
// Material UI
import { Grid, Typography } from '@mui/material';

import { SidePanel, SidePanelBody, SidePanelHeader, SidePanelFooter, Select, Button, Input, Form, TextArea } from '@gpstrackit/gtc-react-controls';

import { createIconMarkerForRoute } from '../../../../../../components/Map/utils'
import { TypeObjectMap, TypeLayer, EnumIconSize, GeofenceRadiusValues } from '../../../../../../components/Map/providers/enums';
import InputRadius from '../../../../../../components/Map/components/InputRadius';

import InputSearchMap from 'Components/Map/components/InputSearchMap';
import { useGeocoder } from 'Core/hooks';
import { NotificationManager } from '../../../../../../components/Notifications';
import Pill from "Components/Pill";
// Views
import EntityPicker from 'Modules/.common/components/EntityPicker';

import { createSelector } from 'reselect'
import { useDataGridThrottler } from 'Core/hooks'
import { getUnitsNaturalOrder } from 'Core/data/Helpers';
import { unitSelectors } from 'Core/realtime/redux/unitSlice';
import { lastReadingSelectors } from 'Core/realtime/redux/lastReadingSlice';

const getVehicleTags = (state) => state.realtimeMapUtilitiesVehiclesListRedux.tagsVehicleList;
const getUnitsCatalog = createSelector([state => unitSelectors.selectAll(state)], getUnitsNaturalOrder);
const getReadingsCatalog = (state) => lastReadingSelectors.selectEntities(state);

/*********************************************************
 * Get information from pagination elements
*********************************************************/
const getData = createSelector(
  [getUnitsCatalog, getReadingsCatalog, getVehicleTags],
  (unitsList, readings, vehicleTags) => {
    let result = []
    unitsList?.forEach((unit) => {
      try {
        if (unit.id == "-1" || (!unit.id && !unit.CUnits_id)) return
        const idUnit = unit.id

        let lastReading = readings?.[idUnit]
        const lat = lastReading?.latitude || unit?.latitude || unit?.lat
        const lng = lastReading?.longitude || unit?.longitude || unit?.lng
        const label = unit?.label || lastReading?.deviceLabel;
        if (!Array.isArray(unit?.tags) || unit.tags.length === 0) {
          unit = { ...unit, tags: [{ color: "000000", hasChildren: false, id: -1, label: "Untagged", parentId: null, path: "" }] }
        }

        //filter unit for existing tag
        unit = {
          ...unit,
          tags: !vehicleTags?.length ? unit.tags : unit.tags?.filter(tag => vehicleTags?.some(vehicleTag => tag?.id == -1 || vehicleTag?.id === tag?.id))
        }

        // if the unit no have tags or none is the group "Untagged", it is omitted
        if (!unit?.tags?.length && !unit?.tags?.some(tag => tag.id === -1)) return; // No is entered on the list of vehicle because no have permisions

        if (!lastReading?.haveLatLng) return; // No is entered on the list of vehicle because no have lat and lng

        const item = {
          id: unit.id || lastReading?.deviceId,
          label: label,
          lat: lat ? parseFloat(lat) : 0,
          lng: lng ? parseFloat(lng) : 0,
          latitude: lat ? parseFloat(lat) : 0,
          longitude: lng ? parseFloat(lng) : 0,
          haveLatLng: lastReading?.haveLatLng, // this vehicle no have lat and lng, cant show on map
          address: lastReading?.address,
          fulladdress: lastReading?.address?.formatted,
          changeLabel: (unit?.label != label),
          changeLatLng: lastReading?.changeLatLng,
          driverName: unit?.driverName,
          lastReading: lastReading,
          tags: unit.tags || []
        }
        result.push(item);
      } catch (e) {
        console.log('e', e)
        NotificationManager.error('Error', `Error src/components/Map/components/FromToMap/index.js to create show list of vehicles - ${e}`, 3000, null, null, 'error');
      }
    });
    return result
  }
)


// Styles
import './style.scss';
// Actions
import {
  catalogLoad,
  selectCreateClickMapType,
  setLatLng,
  pointersCreated,
  addPointers,
  noCenterPointers,
  drawGetDirections,
  onUpdateRoute

} from 'Redux/actions';

import { reset as resetSavedData } from '../createEditRouteModalMain/redux/slice'
import { routesEditPanelRouteGetRoute } from '../editPanelRoute/redux/slice'
import { openModalCreateEditRoutePoint, reset } from './redux/slice'
import { updateErrorOnMap } from '../createEditRouteModalMain/redux/slice'

// This is the maximum number of route points supported for the Google Directions service.
// This limit is associated with the letters of the alphabet.
const maxRoutePoints = 25;

const CreateEditRoutePoint = (props) => {
  const dispatch = useDispatch();
  const { intl, points: paramPoints, mapRef, isRealtimeMaps, parentSetFormData, setPointUnsaved } = props;

  const { messages } = intl;

  const addressTypes = [
    { label: messages['routes_Address'], value: messages['routes_Address'] },
    { label: messages['routes_Unit'], value: messages['routes_Unit'] },
    { label: messages['routes_Landmark'], value: messages['routes_Landmark'] },
    { label: messages['routes_mapClick'], value: messages['routes_mapClick'] }
  ];

  const ListTypePoints = [
    { id: 0, label: messages['routes_create_edit_point_edit_stop'], value: 'Stop' },
    { id: 1, label: messages['routes_create_edit_point_edit_waypoint'], value: 'Waypoint' },
  ];


  const route = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);


  let points = [];
  if (paramPoints) {
    points = paramPoints
  } else if (route && route.points) {
    points = route.points
  }

  const routeId = route?.id || 0

  //const open = useSelector(state => state.routesManagedCreateEditRoutePointRedux.open) || true; //change value for accordion 
  const open = true;
  const createUpdateRoutePointResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.createUpdateRoutePointResponse)
  const errorCreateUpdateRoutePoint = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.erorrRoutes)
  const pointToEdit = useSelector(state => state.routesManagedCreateEditRoutePointRedux.point)
  const errorOnMap = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.errorOnMap);
  //Stop or Waypoint


  const loading = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.loading)
  const loadingCreateRoutePoint = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.loadingCreateRoutePoint)
  const loadingUpdateRoutePoint = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux.loadingUpdateRoutePoint)
  const directionsError = useSelector((state) => state.realtimeMapRedux.directionsError);

  const loadingUnits = useSelector(state => state.catalogsRedux.loadingUnits);
  const { clickLatLng } = useSelector((state) => state.realtimeMapRedux);

  /*********************************************************
   * use compute data to sync values showing in table
  *********************************************************/
  const computedData = useSelector(state => getData(state) || []);
  const propertiesToValidate = useMemo(() => ["label", "lat", "lng", "changeLatLng", "haveLatLng", "tags"], []);

  // Hook handles both Throttled Arrays for `<Map/>` and imperative delta diffing for markers via `handleMapUpdates`
  const units = useDataGridThrottler(
    computedData,
    1000,
    () => { },
    "id",
    propertiesToValidate
  );

  const formAddStop = Form.useForm();

  const [counterPoints, setCounterPoints] = useState(1)
  const [formData, setFormData] = useState({ note: "", stop: null, typePoint: 'Stop' });
  const [pointAdded, setPointAdded] = useState(false)
  const [error, setError] = useState(null);
  const [genericError, setGenericError] = useState(null);
  const [onGetGeocoder, address] = useGeocoder();
  const objectOnMap = 'mapObject_01';
  const objectOnMap2 = 'mapObject_02';
  const idMarker = "createRoutePoint01";
  const defaulRadius = 32.18688; // 0.02 miles;
  const maximunArea = 65535;

  useEffect(() => {
    if (open) {
      dispatch(noCenterPointers(true))
    }
  }, [open]);

  useEffect(() => {
    if (route?.points?.length > 0) {
      setCounterPoints(route?.points?.length + 1)
    }
  }, [])

  useEffect(() => {
    if (counterPoints == 0 && route?.points?.length > 0) {
      setCounterPoints(route?.points?.length + 1)
    }
  }, [route?.points])

  useEffect(() => {
    if ((createUpdateRoutePointResponse) && open && !loadingCreateRoutePoint && !loadingUpdateRoutePoint) {
      if (!errorCreateUpdateRoutePoint) {
        const restarModalEdit =
        {
          loading: false,
          open: true,
          restart: false,
          point: null, //is edit set point
          erorrRoutes: null,
          typePoint: formData?.typePoint
        };

        setFormData(formData => ({ note: "", stop: null, typePoint: formData.typePoint }));
        setPointAdded(false);

        //notify the main component that the point was saved
        setPointUnsaved(false);

        formAddStop.setValues({ name: null, note: null })
        mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
        mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
        mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);

        dispatch(selectCreateClickMapType())
        dispatch(setLatLng(null));

        dispatch(reset(restarModalEdit))

        if (createUpdateRoutePointResponse) {

          setTimeout(() => {
            if (routeId > 0) {
              dispatch(routesEditPanelRouteGetRoute({ id: routeId }));
            }
            dispatch(resetSavedData({ createUpdateRoutePointResponse: false }));
            if (pointToEdit) {
              handleClose();
            }
          }, 500);

        }
      }
    }
  }, [createUpdateRoutePointResponse]);

  useEffect(() => {
    if (clickLatLng) {
      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
      addMarker(clickLatLng, formData.typePoint);
      onGetGeocoder({
        from: 'latlng',
        lat: clickLatLng.lat,
        lng: clickLatLng.lng
      });
      setError(null);
    }
  }, [clickLatLng]);

  useEffect(() => {
    if (address && address.result == true && address.data && address.data.length) {
      const { data } = address;
      const stop = {
        routeId: routeId,
        sequence: (points?.length),
        latitude: data[0]?.lat,
        longitude: data[0]?.lng,
        address: data[0]?.fulladdress,
        city: data[0]?.city,
        state: data[0]?.state,
        typePoint: formData?.typePoint
      };
      setFormData(formData => ({ ...formData, stop: { ...formData?.stop, ...stop } }))
    }
  }, [address, open]);

  useEffect(() => {
    if (pointToEdit) {
      setFormData(formData => ({ ...formData, stop: { ...pointToEdit }, typePoint: pointToEdit.typePoint, note: pointToEdit.note }))
      //zoom on marker
      mapRef?.current?.centerPointOnMap(pointToEdit?.latitude, pointToEdit?.longitude, 18, 0, 3000);

      formAddStop?.setValues({
        name: pointToEdit?.name || null,
        note: pointToEdit?.note || null
      });

      //add the point on map
      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
      //mapRef.current.removeMapObject(pointToEdit.id, TypeObjectMap.Marker);
      mapRef.current.showNormalMarkers();

      addMarker({ lat: pointToEdit.latitude, lng: pointToEdit.longitude }, pointToEdit?.typePoint, pointToEdit.radius, pointToEdit?.counterStop);
    }
  }, [pointToEdit])

  useEffect(() => {
    if (directionsError > 0) {
      dispatch(updateErrorOnMap({ errorOnMap: true }))
    }
  }, [directionsError])

  useEffect(() => {
    if (errorOnMap) {
      dispatch(drawGetDirections(false));
      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
      mapRef.current.removeMapObject(idMarker, TypeObjectMap.Marker);
      dispatch(updateErrorOnMap({ errorOnMap: null }))

      refreshRoute();
    }
  }, [errorOnMap])

  const refreshRoute = () => {
    dispatch(drawGetDirections(false));
    let newPointers = []
    //create the points on map when route comes to data
    route?.points?.map((item) => {
      newPointers.push({
        ...item,
        //value : item?.sequence,
        layerName: TypeLayer?.FSMRoute,
        eventName: item?.typePoint
      })
    });
    setTimeout(() => {
      dispatch(addPointers([...newPointers]));
      dispatch(drawGetDirections(true));
    }, 500);
  }

  const addMarker = useCallback((latLng, paramTypePoint, radius = 0, consecutive = 0) => {

    let consecutiveValue = consecutive > 0 ? consecutive : 0
    if (consecutiveValue == 0 && route?.points?.length > 0) {
      route?.points?.map((element) => {
        consecutiveValue = element?.typePoint == 'Stop' ? consecutiveValue + 1 : consecutiveValue;
      })
    }

    const position = { lat: latLng.lat, lng: latLng.lng };

    const mapObject = {
      layerName: TypeLayer.FSMRoute,
      eventName: paramTypePoint,
      //is edit the point have the same number
      value: pointToEdit ? pointToEdit?.value : consecutiveValue
    }

    const iconMarker = createIconMarkerForRoute(mapObject)

    mapRef.current.addCircleOnMapToCreate(
      position,
      onUpdateList,
      idMarker,
      objectOnMap,
      paramTypePoint == 'Stop' ? radius || defaulRadius : 0,
      maximunArea,
      iconMarker,
      20,
      true,
      callbackDragEnd,
      paramTypePoint
    );

    dispatch(pointersCreated(true));

    let newPointers = []
    //create the points on map when route comes to data
    route?.points?.map((item) => {
      //is edit add the point into the position at the current element
      if (item.id == pointToEdit?.id) {
        newPointers.push({
          id: objectOnMap2,
          name: objectOnMap2,
          typePoint: paramTypePoint,
          latitude: latLng.lat,
          longitude: latLng.lng,
          sequence: mapObject.value,
          ...mapObject,
        });
      } else {
        newPointers.push({
          ...item,
          //value : item?.sequence,
          layerName: TypeLayer?.FSMRoute,
          eventName: item?.typePoint
        })
      }
    });



    if (pointToEdit) {
      //remove the current marker
      mapRef.current.removeMapObject(pointToEdit?.id, TypeObjectMap.Marker);
    } else {
      //is new point added element into the end
      newPointers.push({
        id: objectOnMap2,
        name: objectOnMap2,
        typePoint: paramTypePoint,
        latitude: latLng.lat,
        longitude: latLng.lng,
        sequence: mapObject.value,
        ...mapObject,
      });
    }


    setPointAdded(true)

    //notify the main component that the point was saved
    setPointUnsaved(true);

    dispatch(drawGetDirections(false));
    dispatch(addPointers([]));

    setTimeout(() => {
      dispatch(addPointers([...newPointers]));
      dispatch(drawGetDirections(true));

    }, 500);

    setTimeout(() => {
      mapRef?.current?.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
      mapRef?.current?.centerObjectOnMap(TypeObjectMap.Marker, idMarker, 20, 10, true);
    }, 1000)

  });

  const callbackDragEnd = ({ lat, lng }, typePoint) => {
    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
    mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
    addMarker({ lat, lng }, typePoint);
    onGetGeocoder({
      from: 'latlng',
      lat: lat,
      lng: lng
    });
    setError(null);
  }

  const onUpdateList = (distanceInMetters) => {
    setFormData(formData => ({ ...formData, stop: { ...formData?.stop, radius: Math.round(distanceInMetters) } }))
  }

  const handleClose = useCallback(() => {
    //if (!loading) {
    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
    mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);

    dispatch(noCenterPointers(false))
    formAddStop?.resetValues();
    //refreshRoute();
    setPointAdded(false);

    //notify the main component that the point was saved
    setPointUnsaved(false);

    //dispatch(openAddStop(false));
    dispatch(resetSavedData({ createUpdateRoutePointResponse: false }));
    dispatch(reset())
    dispatch(selectCreateClickMapType())
    setFormData({ note: "", stop: null });
    dispatch(setLatLng(null));
    dispatch(openModalCreateEditRoutePoint({ open: false }))
    setCounterPoints(0)
    //}
  });
  const onSaveData = useCallback(() => {
    let haveError = false;
    if ((formData.typePoint == "Stop" && !formData?.stop?.name)) {
      setError(true);
      haveError = true;
    }

    if ((formData.typePoint == "Stop" && !formData?.stop?.name)) {
      setError(true);
      haveError = true;
    }

    //address validation
    if (formData?.type?.value === messages['routes_Address'] && !pointAdded) {
      setError(true);
      haveError = true;
    }

    //address validation
    if (formData?.type?.value === messages['routes_Unit'] && !pointAdded) {
      setError(true);
      haveError = true;
    }

    const { stop } = formData;
    let tempPoints = [...points]
    //validate the name for the point

    let isValidName = true;
    tempPoints.forEach(element => {
      if (element.typePoint == "Stop" && element.name == stop?.name && element.id != stop?.id) {
        isValidName = false
      }
    });

    if (!isValidName) {
      setGenericError(messages['duplicated_name']);
      haveError = true;
    }


    if (!stop) {
      haveError = true;
      setError(true);
    }

    if (!pointAdded) {
      haveError = true;
      setError(true);
    }

    if (haveError) {
      return
    }

    //clear the error message
    error && setError(null);

    //saved stop
    let latLng = null;
    let coordinates = mapRef?.current?.getCircleCoordinates();
    if (!coordinates) {
      NotificationManager.error(messages['routes_create_edit_point_coordinates_not_found']);
      return
    }
    if (coordinates) {
      latLng = {
        latitude: coordinates[0].latitude,
        longitude: coordinates[0].longitude
      };
    }

    const stopToSave = {
      ...stop,
      latitude: latLng.latitude,
      longitude: latLng.longitude,
      radius: stop?.radius || defaulRadius,
      //is name is mandatory on BD
      name: formData.typePoint == 'Stop' ? stop?.name : stop?.address || messages['routes_create_edit_point_edit_waypoint'],
      layerName: TypeLayer?.FSMRoute,
      eventName: formData?.typePoint,
      typePoint: formData?.typePoint
    }


    //To edit point on the route
    if (pointToEdit) {

      const pointsToSave = [];
      tempPoints.map((item) => {
        if (item.id == pointToEdit?.id) {
          item = {
            ...item,
            ...stopToSave,
            routeId: routeId,
            id: pointToEdit.id,
            note: formData.note,
            name: formData.stop.name,
            sequence: pointToEdit.sequence,
            value: pointToEdit.sequence
          }
        }
        pointsToSave.push(item)
      })

      dispatch(onUpdateRoute({ route: { ...route, points: pointsToSave }, changesToSave: true, drawLineRoute: null }))
      parentSetFormData(formData => ({ ...formData, drawLineRoute: null }))
      handleClose()
      return
    }


    const temporalId = counterPoints * -1;
    //start point
    tempPoints.push({ ...stopToSave, id: temporalId, routeId: routeId, sequence: 0, note: formData.note })

    const pointsToSaveData = [];
    let counterStop = -1;
    tempPoints.map((item, index) => {
      counterStop = item?.typePoint == 'Stop' ? counterStop + 1 : counterStop;
      pointsToSaveData.push({
        ...item,
        sequence: index,
        value: counterStop,
        counterStop: counterStop
      })
    })

    setCounterPoints(counterPoints + 1)
    dispatch(onUpdateRoute({ route: { ...route, points: pointsToSaveData }, changesToSave: true, drawLineRoute: null }))
    parentSetFormData(formData => ({ ...formData, drawLineRoute: null }))


    formAddStop?.resetValues();
    resetToCreatePoint()

  });

  const resetToCreatePoint = () => {
    const restarModalEdit =
    {
      loading: false,
      open: true,
      restart: false,
      point: null, //is edit set point
      erorrRoutes: null,
      typePoint: formData.typePoint
    };

    setFormData(formData => ({ note: "", stop: null, typePoint: formData.typePoint }));
    setPointAdded(false);
    formAddStop.setValues({ name: null, note: null })

    //notify the main component that the point was saved
    setPointUnsaved(false);

    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
    mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);

    dispatch(selectCreateClickMapType())
    dispatch(setLatLng(null));
    dispatch(reset(restarModalEdit))
  }

  const validateSaveElements = () => {
    let isInvalid = false;

    //if no select the type of point
    if (!pointToEdit?.id && !formData?.type) {
      isInvalid = true;
    }

    //validate max points elements on the route
    if (points?.length >= maxRoutePoints) {
      isInvalid = true;
    }

    return isInvalid;
  }

  const handleToggle = () => {
    //closeEditPanel && closeEditPanel(!showEditPanel)
  }

  const onChangeRadius = useCallback((radius) => {
    setFormData(formData => ({ ...formData, stop: { ...formData?.stop, radius: radius } }))
    mapRef?.current?.updateCirclePoint(objectOnMap, null, radius, true);
  });

  return (

    <Form
      ref={formAddStop.ref}
      onValidSubmit={onSaveData}
      //loading={loading}                      
      onChangeValues={(values) => {
      }}
    >
      <div style={{ padding: 10 }}>
        {
          !pointToEdit
          &&
          <div>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              style={{ marginBottom: 10 }}
            >
              {
                ListTypePoints.map((item) => {
                  return (
                    <Grid key={`grid_point_${item?.id}`} item xs>
                      <Pill
                        key={`pill_point_${item?.id}`}
                        textField={'label'}
                        item={item}
                        outlined={item?.value !== formData?.typePoint || false}
                        onClick={(value) => {
                          if (formData?.typePoint == value?.value) return;

                          setFormData(formData => ({ ...formData, typePoint: value.value, type: null }));
                          error && setError(null);

                          //remove the point into the UI
                          mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                          mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                          mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                          setPointAdded(false);

                          //notify the main component that the point was saved
                          setPointUnsaved(false);

                          //refresh the route wiht the current points
                          if (pointAdded) {
                            refreshRoute();
                          }

                        }}
                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                        label="pill-label-text"
                        colorField="default"
                        colorSelection={'66BB6A'}
                      />
                    </Grid>
                  )
                })
              }
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={1}
              style={{ marginBottom: 10 }}
            >
              {
                addressTypes.map((item) => {
                  return (
                    <Grid key={item?.value} item xs>
                      <Pill
                        key={item?.value}
                        textField={'label'}
                        item={item}
                        outlined={item?.value !== formData?.type?.value || false}
                        onClick={(value) => {
                          if (formData?.type?.value == value?.value) return;

                          error && setError(null);
                          setFormData(formData => ({ ...formData, type: value, unit: null, stop: null }))
                          formAddStop.setValues({ name: null, note: null })
                          formAddStop?.resetValues();
                          if (value && value?.value === messages['routes_mapClick']) {
                            dispatch(selectCreateClickMapType(TypeObjectMap.MapClick))
                          }

                          //remove the point into the UI
                          mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                          mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                          mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                          setPointAdded(false);

                          //notify the main component that the point was saved
                          setPointUnsaved(false);

                          //refresh the route wiht the current points
                          if (pointAdded) {
                            refreshRoute();
                          }

                        }}
                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                        label="pill-label-text"
                        colorField="default"
                        colorSelection={'66BB6A'}
                      />
                    </Grid>
                  )
                })
              }
            </Grid>
          </div>
        }
        {
          (!pointToEdit && !loading)
          &&

          <div style={{ marginTop: 10 }}>
            {
              (formData?.type && formData?.type?.value === messages['routes_Address'])
              &&
              <div>
                <label className="input-normal-label">
                  {messages['routes_selectAddress']} <span className="text-danger"> *</span>
                </label>

                <div style={{ marginTop: 5 }}>
                  <InputSearchMap
                    normalView
                    noMap
                    onGetAddress={(value) => {
                      if (value && value?.length) {
                        const address = value[0];

                        const stop = {
                          name: formData?.stop?.name,
                          routeId: routeId,
                          note: "",
                          sequence: (points?.length),
                          latitude: address?.lat,
                          longitude: address?.lng,
                          address: address?.fulladdress,
                          city: address?.city,
                          state: address?.state,
                          typePoint: formData.typePoint
                        };
                        mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                        mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                        mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                        setFormData(formData => ({ ...formData, stop: stop }))
                        addMarker(address, formData.typePoint);
                      }
                      setError(null);
                    }}
                    onClear={() => {
                      setFormData(formData => (
                        {
                          ...formData,
                          stop: { ...formData.stop, latitude: 0, longitude: 0 }
                        }));
                      setPointAdded(false);

                      //notify the main component that the point was saved
                      setPointUnsaved(false);

                      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                    }}
                    onClearSetAddress={() => {
                      setFormData(formData => (
                        {
                          ...formData,
                          stop: { ...formData.stop, latitude: 0, longitude: 0 }
                        }));
                      setPointAdded(false);

                      //notify the main component that the point was saved
                      setPointUnsaved(false);

                      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                    }}
                    onClearInput={() => {
                      setFormData(formData => (
                        {
                          ...formData,
                          stop: { ...formData.stop, latitude: 0, longitude: 0 }
                        }));
                      setPointAdded(false);

                      //notify the main component that the point was saved
                      setPointUnsaved(false);

                      mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                      mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                      mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                    }}


                    draggable={false}
                    noOptionsText={messages['noOptions']}
                    placeholder={messages['search']}
                  />
                </div>

                {
                  (error && (formData?.type?.value === messages['routes_Address'] && !pointAdded)) &&
                  <small className="text-danger" style={{ paddingTop: 5 }}>
                    {`${formData?.type?.value} ${messages['route_required_field']} ${messages['required_field']}`}
                  </small>
                }
              </div>
            }

            {
              (formData?.type && formData?.type?.value === messages['routes_Unit'])
              &&
              <div>
                <label className="input-normal-label">
                  {messages['routes_selectUnit']} <span className="text-danger"> *</span>
                </label>
                <Select
                  style={{
                    width: '100%'
                  }}
                  id="unit"
                  name="unit"
                  //label={messages['routes_selectUnit']}
                  placeholder={messages['routes_selectUnit']}
                  value={formData.unit}
                  onChange={(value) => {
                    const { latitude, longitude, address } = value;
                    const stop = {
                      name: formData?.stop?.name,
                      routeId: routeId,
                      note: "",
                      sequence: (points?.length),
                      latitude: latitude,
                      longitude: longitude,
                      address: address?.address,
                      city: address?.city,
                      state: address?.state,
                      typePoint: formData.typePoint

                    };
                    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                    mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                    setFormData(formData => ({ ...formData, unit: value, stop: stop }))
                    addMarker({ lat: latitude, lng: longitude }, formData.typePoint);
                  }}
                  loading={loadingUnits}
                  options={units}
                  textField={'label'}
                  valueField={'id'}
                  isSearchable
                />
                {
                  (error && (formData?.type?.value === messages['routes_Unit'] && !pointAdded)) &&
                  <small className="text-danger" style={{ paddingTop: 10 }}>
                    {`${formData?.type?.value} ${messages['route_required_field']} ${messages['required_field']}`}
                  </small>
                }
              </div>
            }

            {
              (formData?.type && formData?.type?.value === messages['routes_Landmark'])
              &&
              <div>
                <EntityPicker
                  id="landmarks_routes"
                  name="landmarks_routes"
                  entity="landmarks"
                  required
                  onChange={(value) => {
                    const stop = {
                      name: formData?.stop?.name,
                      landmarkId: value?.id,
                      routeId: routeId,
                      note: "",
                      sequence: (points?.length),
                      latitude: value?.latitude,
                      longitude: value?.longitude,
                      address: value?.address,
                      city: value?.city,
                      state: value?.state,
                      typePoint: formData.typePoint
                    };
                    mapRef?.current?.removeLayer(TypeLayer.CircleCreate);
                    mapRef.current.removeMapObject(objectOnMap, TypeObjectMap.Circle);
                    mapRef.current.removeMapObject(objectOnMap2, TypeObjectMap.Marker);
                    setFormData(formData => ({ ...formData, unit: value, stop: stop }))
                    addMarker({ lat: value?.latitude, lng: value?.longitude }, formData.typePoint);
                  }}
                  value={formData?.unit}
                />
                {
                  (error && (formData?.type?.value === messages['routes_Landmark'] && !pointAdded)) &&
                  <small className="text-danger" style={{ paddingTop: 10 }}>
                    {`${formData?.type?.value} ${messages['route_required_field']} ${messages['required_field']}`}
                  </small>
                }
              </div>
            }
            {/* Error validations */}
            {
              (!pointAdded && formData?.type && formData?.type?.value === messages['routes_mapClick'] && error)
              &&
              <div>
                <small className="text-danger" style={{ paddingTop: 5 }}>
                  {messages['route_required_field_click']}
                </small>
              </div>
            }
            {
              (points?.length >= maxRoutePoints)
              &&
              <div>
                <small className="text-danger" style={{ paddingTop: 5 }}>
                  {messages['routes_create_edit_max_points'].replace('{points}', maxRoutePoints)}
                </small>
              </div>
            }
          </div>
        }

        {
          formData?.typePoint == "Stop"
          &&
          <div style={{ marginTop: 10 }}>
            <label className="input-normal-label">
              {messages['routes_create_edit_point_name']} <span className="text-danger"> *</span>
            </label>
            <Input
              id="name"
              type="text"
              placeholder={messages['routes_create_edit_point_name']}
              maxLength={300}
              value={formData?.stop?.name || ""}
              onChange={(value) => {
                setGenericError(false)
                setFormData(formData => ({ ...formData, stop: { ...formData.stop, name: value } }))
              }}
            />
            {
              (!formData?.stop?.name && error) &&
              <small className="text-danger" style={{ paddingTop: 10 }}>
                {`${messages['routes_create_edit_point_name']} ${messages['route_required_field']} ${messages['required_field']}`}
              </small>
            }
            {
              genericError &&
              <small className="text-danger" style={{ paddingBottom: 10, display: 'block' }}>
                {`${genericError}`}
              </small>
            }
          </div>
        }
        {
          formData?.typePoint == "Stop"
          &&
          <div style={{ paddingTop: 10 }}>
            <InputRadius
              value={formData?.stop?.radius || defaulRadius}
              onChange={onChangeRadius}
              isSquare={false}
            >
            </InputRadius>
          </div>
        }
        <Form.Item
          name="note"
          label={messages['routes_create_edit_point_notes']}
        >
          <TextArea
            id="note"
            placeholder={messages['routes_create_edit_point_notes']}
            maxLength={200}
            className='textAreaRouteClass'
            onChange={(value) => setFormData(formData => ({ ...formData, note: value }))}
          />

        </Form.Item>
      </div>
      <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
      }}
      >
        <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', flexGrow: 1 }}>
          <Typography className='route-modal-label' >{messages["fsmRoute_label_display"]}:</Typography>
          <label
            style={{ textDecoration: 'underline', color: '#00AEEF', cursor: 'pointer', padding: '0px 5px' }}
            className='route-modal-value'
            onClick={() => {
              mapRef.current.centerObjectOnMap(TypeObjectMap.Marker, idMarker, 20, 0, true);
            }}
          >
            {messages['fsmRoute_modal_label_street_level']}
          </label>
          <label style={{ padding: '0px 5px' }}>{" | "}</label>
          <label
            style={{ textDecoration: 'underline', color: '#00AEEF', cursor: 'pointer', padding: '0px 5px' }}
            className='route-modal-value'
            onClick={() => {
              const coordinatesCenter = []
              route?.points?.forEach(element => {
                coordinatesCenter.push({
                  lat: element.latitude, lng: element.longitude
                })
              });
              mapRef.current.centerByFitBounds(coordinatesCenter)
            }}>
            {messages['fsmRoute_modal_label_route_level']}
          </label>
        </div>


        <Button
          onClick={(e) => {
            if (e) e.preventDefault();
            //remove the marker
            handleClose();
            setTimeout(() => {
              refreshRoute();
            }, 500);
          }}
          style={{ whiteSpace: 'nowrap' }}
          variant="secondary"
        >
          {messages['fsmRoute_edit_panel_route_accordion_clear']}
        </Button>
        <div style={{ paddingLeft: 10 }}>
          <Button
            variant="primary"
            style={{ whiteSpace: 'nowrap' }}
            onClick={(e) => {
              e?.preventDefault();
              formAddStop?.submit();
              //onSaveData()
            }}
            isDisabled={loading || loadingCreateRoutePoint || loadingUpdateRoutePoint || validateSaveElements() || errorOnMap}
          >
            {
              pointToEdit
                ?
                messages['routes_create_edit_point_button_update']
                :
                messages['routes_create_edit_point_button_add']
            }
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default injectIntl(memo(CreateEditRoutePoint));
